import AcceptQuoteThankYouDialog from './AcceptQuoteThankYouDialog'
import type { AcceptQuoteThankYouDialogProps } from './AcceptQuoteThankYouDialog'

export type { AcceptQuoteThankYouDialogProps }
export default AcceptQuoteThankYouDialog
